import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";
import {NotepadType} from "../../../model2/notepad/const";

const fieldsConfig = {

    'bgColor': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false
    },

    'menuFull': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true
    },

    'newNotepadType': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : NotepadType.TEXT,
        options         : [NotepadType.TEXT, NotepadType.RTF]
    }
}

const debug = false
// const debug = "UserSettingsViewsMyWork"

export default class UserSettingsViewsNotepad extends ServerSettings {

    public bgColor: boolean
    public menuFull: boolean
    public newNotepadType: NotepadType

    constructor(config: any) {

        super(config, fieldsConfig);

        // default current view
        this.bgColor    = this.initValue('bgColor')
        this.menuFull    = this.initValue('menuFull')
        this.newNotepadType    = this.initValue('newNotepadType')

        // this.viewsSettings  = this.initValue('viewsSettings')
    }


    toJson() {
        const result = {};

        this.valueToJson(result, 'bgColor')
        this.valueToJson(result, 'menuFull')
        this.valueToJson(result, 'newNotepadType')

        debug && console.log(debug, 'toJson', result, this)

        return result;
    }
}
